<template>
    <div class="space-y-5">
        <slot />
    </div>
</template>
